export default {
  english: {
    label: 'Share on Reddit',
  },
  french: {
    label: 'Partager sur Reddit',
  },
  arabic: {
    label: 'انشر على Reddit',
  },
  hebrew: {
    label: 'שתף ב-Reddit',
  },
  persian: {
    label: 'در Reddit به اشتراک بگذارید',
  },
}
